Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tileFontSize: 14,
    tileForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    tileForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    tileBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    tileBorderWidth: 1,
    tileBorderRadius: 4,
    tileBorderColor: tokens.themeBorderTertiaryDefault,
    tileSpacingInset: 8,
    tileAccentColorSuccess: "#ADE422",
    tileAccentColorWarning: "#FAD000",
    tileAccentColorError: "#CC0C39",
    tileAccentColorNeutral: tokens.themeForegroundPrimaryDisabled,
    tileAccentColorTheme: tokens.themeBorderAccentDefault,
    tileAccentColorDisabled: tokens.themeBorderTertiaryDefault,
    tileAccentWidth: 6,
    tileActionHeight: 40,
    tileActionForegroundColorDefault: tokens.themeForegroundAccentDefault,
    tileActionForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    tileActionBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    tileActionBackgroundColorHover: tokens.themeBackgroundSecondaryDefault,
    tileActionBackgroundColorPressed: tokens.themeBackgroundTertiaryDefault,
    tileDropShadowDefaultOffsetX: 0,
    tileDropShadowDefaultOffsetY: 2,
    tileDropShadowDefaultBlur: 4,
    tileDropShadowDefaultSpread: 0,
    tileDropShadowDefaultColor: "rgba(11, 12, 12, 0.16)",
    tileDropShadowHoverOffsetX: 0,
    tileDropShadowHoverOffsetY: 4,
    tileDropShadowHoverBlur: 8,
    tileDropShadowHoverSpread: 0,
    tileDropShadowHoverColor: "rgba(11, 12, 12, 0.16)",
    tileDropShadowPressedOffsetX: 0,
    tileDropShadowPressedOffsetY: 3,
    tileDropShadowPressedBlur: 6,
    tileDropShadowPressedSpread: 0,
    tileDropShadowPressedColor: "rgba(11, 12, 12, 0.16)",
    tileOffsetVerticalDefault: 0,
    tileOffsetVerticalHover: -4,
    tileOffsetVerticalPressed: -2
  }
};